import { render, staticRenderFns } from "./TabelaPagamentos.vue?vue&type=template&id=8b7ba1b2&"
import script from "./TabelaPagamentos.vue?vue&type=script&lang=js&"
export * from "./TabelaPagamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports